import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=61a795c5&scoped=true"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=61a795c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a795c5",
  null
  
)

export default component.exports